module.exports = __webpack_public_path__ + "static/media/ham.0ab3f179.svg";